var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_vm._v(" "+_vm._s(_vm.perUpgrade)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.tickspeedDisplay)+" "),_c('br'),_c('GameSpeedDisplay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }